import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import './OrphanPage.scss';
import { AgGridColumn, AgGridReact, ChangeDetectionStrategyType } from 'ag-grid-react';
import useWindowSize from '../../utils/useWindowSize';
import { BREAKPOINTS, FILTER_LABEL_NAME, FILTER_GROUP_NAMES, EXPORT_LOOKUP_CONSTANTS, ROWS_DROPDOWN_OPTIONS, ORPHAN_ANAMOLIES_TEXT } from '../../constants/constants';
import { OpportunityCellRenderer, PrevOpportunityCellRenderer } from '../allOpportunity/OpportunityCellRenderer';
import { ActionCellRenderer } from '../allOpportunity/ActionCellRenderer';
import { useAppDispatch } from '../../store';
import { Button, Icon, Search, Modal, Loader, Select, Tooltip } from '@scuf/common';
import { downloadAllOpportunity, getAutoSearchForOpportunity } from '../../services/Opportunities';
import { GridPagination } from '../allOpportunity/GridPagination';
import { getUserInfo } from '../../slices/userProfileSlice';
import { IAutoSearch } from '../../models/IAllOpportunitiesModel';
import OpportunitiesErrorCard from '../dashboard/OpportunitiesErrorCard';
import { NotesIcon } from '../allOpportunity/NotesIcon';
import { USER_ROLE } from '../../constants/constants';
import { toast } from 'react-toastify';
import { getOnBoardingAPIData, getOnBoardingAPIStatus, getCurrentRole } from '../../slices/onBoardingSlice';
import Notes from "src/components/OpportunityModal/NewCardDesign/Notes/Notes";
import NotesFooter from "src/components/OpportunityModal/NewCardDesign/Notes/NotesFooter";

import { StatusCellRenderer } from '../allOpportunity/StatusCellRenderer';
import { AuditStatusCellRenderer } from '../allOpportunity/AuditStatusCellRenderer';
import { BusinessStatusCellRenderer } from '../allOpportunity/BusinessStatusCellRenderer';
import ActionTrackingStatusCellRenderer from '../allOpportunity/ActionTrackingStatusCellRenderer';
import { addFilter, addSort, clearAllFilters, getOrphanFiltersSelector, getAllOrphanOpportunitiesSelector, getallOrphanOpportunities, getOrphanPaginationSelector, getSortOrphanSelector, removeSort, setExportStatus, setPaginationCurrentPage, addOrphanFilters, setPaginationItemPerPage } from '../../slices/orphanSlice';
import { getLookupStatus, getLookupStatusSelector, getDetailedView, getLastPageBeforeLandingDetailedPage, setLastPageBeforeLandingDetailedPage } from '../../slices/allOpportunitySlice';
import AnomalyFilters from 'src/components/AnomalyFilters/AnomalyFilters';
import ExportAnomaly from 'src/components/ExportAnomaly/ExportAnomaly';
import { OverviewBadges } from 'src/pages/allOpportunity/OverviewBadges';
import ReviewButton from 'src/components/SummaryStatistics/ReviewButton';
import { getQuickSummarySelector, getAllExportFiltersSelector, clearExportFilter } from '../../slices/allOpportunitySlice';
import FontIcon from 'src/components/FontIcon/FontIcon';
import { getMessage } from 'src/message/utils';

const OrphanPage = () => {
    const dispatch = useAppDispatch();
    const { status, data } = useSelector(getAllOrphanOpportunitiesSelector);
    const exportFilter = useSelector(getAllExportFiltersSelector);
    const quickSummary = useSelector(getQuickSummarySelector);
    const orphanFilter = useSelector(getOrphanFiltersSelector);
    const { quickSummaryType } = useSelector(getQuickSummarySelector);
    const [localPageNumber, setLocalPageNumber] = useState(1);
    const gridRef = useRef();
    const { eid } = useSelector(getUserInfo);
    const { itemPerpage, currentPage } = useSelector(getOrphanPaginationSelector);
    const { width, height: vHeight } = useWindowSize();
    const [gridApi, setGridApi] = useState(null);
    const [result, setResult] = useState<IAutoSearch[]>([]);
    const [selectedSearchResults, setSelectedSearchResults] = useState('');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [showSummaryStatistics, toggleSummaryStatistics] = useState(false)
    const [rowsNumber, setRowsNumber] = useState<any>("10")
    const [rowsOptions, setRowsOptions] = useState<any>([{ value: "10", text: "10" }])
    const [rowSelectedCount, setRowSelectedCount] = useState(0);
    const [isNoRecords, setIsNoRecords] = useState(false);
    const largeDevice = width && width > BREAKPOINTS.MD ? true : false;
    const smallDevice = width && width <= BREAKPOINTS.XS ? true : false;
    const [showNotesIconPopup, setShowNotesIconPopup] = useState(false);
    const [selectedInsightId, setSelectedInsightId] = useState<string[]>([]);
    const [notesData, setnotesData] = useState<any>({}); //TODO add any
    const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
    const userOnboardData = useSelector(getOnBoardingAPIData);
    const gridSort = useSelector(getSortOrphanSelector);
    const { status: lookupStatus, data: filtersList } = useSelector(getLookupStatusSelector);
    const [gridLoading, setGridLoading] = useState<boolean>(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [pageMap, setPageMap] = useState<Object>({});
    let rowData = data?.opportunity_detail || [];
    rowData = status === 'error' ? [] : rowData;
    const totalRecord = data?.metadata?.total_row_count || 0;
    const detailedView = useSelector(getDetailedView);
    const lastPageBeforeLandingDetailedPage = useSelector(getLastPageBeforeLandingDetailedPage);
    const [pageMapModule, setPageMapModule] = useState<any>([]);
    const [uniqueDomain, setUniqueDomain] = useState<string[]>([]);
    const current_role = useSelector(getCurrentRole);
    const [exportDefaultLabels, setExportDefaultLabels] = useState(["Anomaly ID", "Alerts", "Actions", "Country", "Regions", "SBG", "GBE", "Source System", "Spend Type", "Target Group", "Company Code", "Sub Region"]);
    const [showRowCount, setShowRowCount] = useState<boolean>(false);    
    const searchUserPlaceholder = getMessage('app.anomalies.search.user.placeholder');
    const searchPlaceholder = getMessage('app.anomalies.search.placeholder');
    const minCharsToSearch = getMessage('app.anomalies.search.minchars');
    const noRecordFound = getMessage('app.anomalies.search.norecordfound');
    const loadingSuggestions = getMessage('app.anomalies.search.loading');
    const selectedFilterText = getMessage('app.anomalies.action.filter.selected');
    const anomalyIdHeader = getMessage('app.anomalies.grid.column.anomalyId');
    const prevAnomalyIdHeader = getMessage('app.anomalies.grid.column.prevanomalyid');
    const alertsHeader = getMessage('app.anomalies.grid.column.alerts');
    const actionsHeader = getMessage('app.anomalies.grid.column.actions');
    const countryHeader = getMessage('app.anomalies.orphan.grid.column.country');
    const regionHeader = getMessage('app.anomalies.orphan.grid.column.region');
    const subRegionHeader = getMessage('app.anomalies.orphan.grid.column.subregion');
    const sbgHeader = getMessage('app.anomalies.orphan.grid.column.sbg');
    const gbeHeader = getMessage('app.anomalies.orphan.grid.column.gbe');
    const spendTypeHeader = getMessage('app.anomalies.orphan.grid.column.spendtype');
    const targetGroupHeader = getMessage('app.anomalies.orphan.grid.column.targetgrp');
    const companyCodeHeader = getMessage('app.anomalies.grid.column.companycode');
    const sourceSystemHeader = getMessage('app.anomalies.grid.column.sourcesystem');

    useEffect(() => {
        if (status === 'idle' && lookupStatus === 'finished' && userOnboardAPIStatus === 'finished') {
            dispatch(getallOrphanOpportunities());
        }

        if (lookupStatus === 'idle' && userOnboardAPIStatus === 'finished') {
            dispatch(getLookupStatus());
        }
        if (status === "loading") {
            if (gridApi != null) {
                setGridLoading(false);
                //@ts-ignore
                gridApi.showLoadingOverlay();
            } else {
                setGridLoading(true);
            }
        } else if (status === "finished" && gridApi != null) {
            //@ts-ignore
            gridApi?.hideOverlay();
            setGridLoading(false);
            setSelectedNodes(gridRef?.current);
        } else if (status === "error") {
            setGridLoading(false);
        }

    }, [status, userOnboardAPIStatus, lookupStatus]);

    useEffect(() => {
        setLocalPageNumber(1);
        dispatch(setPaginationCurrentPage(1));
        if (!detailedView) {
            dispatch(getallOrphanOpportunities());
        }
        const roles: string = userOnboardData?.roles && userOnboardData?.roles.length > 0 ? userOnboardData.roles[0] : '';
        toast(<div className='fi-toast__sampling'><Icon root="global" className='toasticon__sampling' name="reminders" size="medium" />{ORPHAN_ANAMOLIES_TEXT}</div>, {
            position: 'bottom-right',
            className: 'fi-toast__sampling--content samplingtoast-success-container-after',
            bodyClassName: 'fi-toast__sampling--body',
        });
        handleRowsOptions();
        Number(itemPerpage) > Number(totalRecord) ? setRowsNumber("") : setRowsNumber(`${itemPerpage}`);
    }, [])

    useEffect(() => {
        Number(itemPerpage) > Number(totalRecord) ? setRowsNumber("") : setRowsNumber(`${itemPerpage}`);
    },[data?.metadata?.total_row_count])

    useEffect(() => {
        let rowData = data?.opportunity_detail || [];
        rowData = status === 'error' ? [] : rowData;
        let rowLength = rowData.length;
        (rowLength < itemPerpage) ? setShowRowCount(true): setRowsNumber(`${itemPerpage}`);
    },[data?.opportunity_detail, itemPerpage, status])

    useEffect(() => {
        if (detailedView) {
            setLocalPageNumber(lastPageBeforeLandingDetailedPage);
        }
    }, [detailedView]);



    const onExportData = () => {
        setShowExportPopup(true)
    }

    const filterClose = () => {
        setIsFilterOpen(false);
    }

    const onApplyorReset = () => {
        setLocalPageNumber(1);
        dispatch(setPaginationCurrentPage(1));
    }

    const setSelectedNodes = (params: any) => {
        let nodes = params.api.getRenderedNodes();
        nodes.forEach((node: any) => {
            if (selectedInsightId.includes(node.data.insight_id.toString())) {
                node.setSelected(true);
            }
        })
    }


    const onGridReady = (params: any) => {
        setGridApi(params.api);
        if (largeDevice) {
            params.api.sizeColumnsToFit();
        }
    }


    const onSelectionChanged = (event: any) => {
        const modules: any = [];
        const selectedNodes = event.api.getSelectedNodes();
        const selectedNodeInsightId = selectedNodes.map((data: any) => {
            modules.push(data.data.insight_module_name);
            return data.data.insight_id.toString();
        });

        /* Preparing Unique Module */
        let pageMapModuleTemp = { ...pageMapModule };
        //@ts-ignore
        pageMapModuleTemp[localPageNumber as keyof typeof pageMapModuleTemp] = modules;
        setPageMapModule(pageMapModuleTemp);
        //@ts-ignore
        let allModuleSingle: any = Object.values(pageMapModuleTemp).reduce((elem1, elem2) => elem1.concat(elem2));
        let newuniqueDomain: any = [...new Set(allModuleSingle)];
        setUniqueDomain(newuniqueDomain);
        /* End of Preparing Unique Module */

        let pageMapTemp = { ...pageMap };
        //@ts-ignore
        pageMapTemp[localPageNumber as keyof typeof pageMapTemp] = selectedNodeInsightId;
        //@ts-ignore
        let single = Object.values(pageMapTemp).reduce((elem1, elem2) => elem1.concat(elem2));
        setPageMap(pageMapTemp);
        setRowSelectedCount(single.length);
        //@ts-ignore
        setSelectedInsightId(single);
    }


    const displayExportToast = () => {
        toast(<div>
            <span className='toast__sampling'>{`Please select atleast one anomaly or more than one anomaly to export.`}
            </span>
            <a onClick={downloadAllExportData}>Download All Anomalies </a>
        </div>, {
            position: 'top-right',
            className: 'toast__sampling--content toast__sampling--format',
            bodyClassName: 'toast__sampling--body',
            closeButton: true
        });
    }

    const downloadAllExportData = () => {
        if (gridApi != null) {
            const roles: string = userOnboardData?.roles && userOnboardData?.roles.length > 0 ? userOnboardData.roles[0] : '';
            dispatch(setExportStatus(true));
            let newOrphanFilters: any = [];
            newOrphanFilters = [{ column: EXPORT_LOOKUP_CONSTANTS.DEFAULT_LABEL, value: exportDefaultLabels, type: 'in' }, { column: EXPORT_LOOKUP_CONSTANTS.INSIGHT_ID, value: [], type: "in" }, { column: EXPORT_LOOKUP_CONSTANTS.LABEL_GROUP, value: [], type: "in" }, ...orphanFilter.filter((item: any) => {
                return !item.value.includes("All") && !item.value.includes("all");
            })];
            downloadAllOpportunity(newOrphanFilters, { itemPerpage: totalRecord, currentPage }, +totalRecord, eid, roles, gridSort, false, {}, quickSummary.quickSummaryType, current_role, true)
                .then((response: any) => {
                    dispatch(setExportStatus(false));
                })
                .catch(() => {
                    console.error("Export Error");
                })

        }
    }

    const onPageChanged = (page: number, currentPerPage: number) => {
        dispatch(setPaginationCurrentPage(page));
        setLocalPageNumber(page);
        dispatch(getallOrphanOpportunities());
        dispatch(setLastPageBeforeLandingDetailedPage(page))
    }

    const updateOrphanFilters = (column: string, val: any) => {
        let orphanFilter_new = [...orphanFilter];
        let filterObject = orphanFilter.find((filter) => filter.column === column);
        let newFilter: any = {};
        orphanFilter_new = orphanFilter_new.filter((filterVal) => filterVal.column !== column);
        if (filterObject && filterObject.value.length > 1) {
            if (Array.isArray(filterObject.value) || Array.isArray(filterObject.displayValues)) {
                if (filterObject.displayValues) {
                    let filteredDisplays = filterObject.displayValues.filter(value => val.text !== value);
                    //@ts-ignore
                    let filteredValues = filterObject.value.filter(value => val.value !== value);
                    newFilter = {
                        column: column,
                        type: filterObject.type,
                        value: [...filteredValues],
                        displayValues: [...filteredDisplays]
                    }
                }
                else {
                    //@ts-ignore
                    let filtered = filterObject.value.filter(value => val.value !== value);
                    newFilter = {
                        column: column,
                        type: filterObject.type,
                        value: [...filtered]
                    }
                }
            }
            orphanFilter_new = [...orphanFilter_new, newFilter]
        }
        dispatch(addOrphanFilters(orphanFilter_new));
        dispatch(getallOrphanOpportunities());
        setLocalPageNumber(1);
    }

    function isFirstColumn(params: any) {
        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

    const downloadExportData = () => {
        if (gridApi != null) {
            //setExportTxt("Exporting...");
            dispatch(setExportStatus(true));
            const roles: string = userOnboardData?.roles && userOnboardData?.roles.length > 0 ? userOnboardData.roles[0] : '';
            downloadAllOpportunity(exportFilter, { itemPerpage: totalRecord, currentPage }, +totalRecord, eid, roles, gridSort, false, {}, quickSummary.quickSummaryType, current_role, true)
                .then((response: any) => {
                    // setExportTxt("Export");
                    dispatch(setExportStatus(false));
                })
                .catch(() => {
                    console.error("Export Error");
                    // console.log("Export Issue")
                })

        }
        dispatch(clearExportFilter([]))
    }

    const handleSearchSelect = (result: any) => {
        setSelectedSearchResults(result.title);
        dispatch(setPaginationCurrentPage(1));
        dispatch(addFilter({ groupName: FILTER_GROUP_NAMES.SEARCH, label: FILTER_LABEL_NAME.SEARCH, value: [result.title], column: result.column_name, type: 'in' }));
        dispatch(getallOrphanOpportunities());
        setLocalPageNumber(1);
    }

    const handleSearchChange = (value: string) => {
        if (value && value.length >= 3 && selectedSearchResults !== value) {
            getAutoSearchForOpportunity(value, false, current_role, true)
                .then((response: any) => {
                    setResult(response);
                    setIsNoRecords(response.length > 0 ? false : true);
                })
                .catch(() => {
                    console.log("Auto-Complete Issue");
                    setIsNoRecords(true);
                });
        } else if (value && value.length > 3 && result.length > 0) {
            const results = result.filter((item: any) => item.title.toLowerCase().includes(value.toLowerCase()));
            setResult(results);
            setIsNoRecords(results.length > 0 ? false : true);
        } else if (value && value.length < 3) {
            setResult([]);
            setIsNoRecords(false);
        }
        setSelectedSearchResults(value);
        setLocalPageNumber(1);
    }
    const onCellClickSort = (event: any) => {
        const sortedColumn = event.columnApi.columnController.gridColumns.filter((item: any) => item.sortIndex >= 0);
        if (sortedColumn.length > 0) {
            dispatch(addSort({ orderBy: sortedColumn[0].sort, columnName: sortedColumn[0].colId }));
            dispatch(getallOrphanOpportunities());
        } else if (gridSort.columnName) {
            dispatch(removeSort());
            dispatch(getallOrphanOpportunities());
        }
        setLocalPageNumber(1);
    }
    const onClearAllFilter = () => {
        dispatch(clearAllFilters([]));
        dispatch(getallOrphanOpportunities());
        setRowSelectedCount(0);
        setLocalPageNumber(1);
    }
    const handleRowsOptions = () => {
        const a = ROWS_DROPDOWN_OPTIONS
        const rowsOp = [...rowsOptions]
        a?.map((data: any) => {
            rowsOp.push({ value: data, text: data });
        });
        setRowsOptions([...rowsOp])
    }
    const handleChangeRowsOption = (value: any) => {
        if (Number(totalRecord) <= parseInt(value)) {
            setRowsNumber("")
        } else {
            setRowsNumber(value)
        }
        dispatch(setPaginationCurrentPage(1));
        dispatch(setPaginationItemPerPage(parseInt(value)))
        dispatch(getallOrphanOpportunities());
        setLocalPageNumber(1);
    }
    return (
        <div>
            {userOnboardData && userOnboardData.roles?.length
                && (userOnboardData?.roles[0] == USER_ROLE.POWER_USER || userOnboardData?.roles[0] == USER_ROLE.LEADERSHIP_USER) &&
                <div className='review_summary'>
                    <ReviewButton showSummaryStatistics={showSummaryStatistics} toggleSummaryStatistics={toggleSummaryStatistics} addExtraWidth />
                </div>
            }
            <div className={`${userOnboardData && userOnboardData.roles?.length
                && (userOnboardData?.roles[0] == USER_ROLE.POWER_USER || userOnboardData?.roles[0] == USER_ROLE.LEADERSHIP_USER) ? 'anomaly_content_align' : 'anomaly_content'}`}>
                {/* <div className="sampleanamoly"> */}
                <div className="anomaliesHeader">
                    <div className="anomaliesHeader__actions">
                        <div>
                            <Search
                                className="allopportunity__actions--search"
                                noResultsMessage={selectedSearchResults.length >= 3 ? isNoRecords ? noRecordFound : loadingSuggestions : minCharsToSearch}
                                results={result}
                                value={selectedSearchResults}
                                placeholder={`${(userOnboardData && userOnboardData.roles?.length && (userOnboardData.roles[0] === USER_ROLE.LEADERSHIP_USER || userOnboardData.roles[0] === USER_ROLE.POWER_USER)) ? searchUserPlaceholder : searchPlaceholder}`}
                                onResultSelect={(value) => handleSearchSelect(value)}
                                onSearchChange={(value) => handleSearchChange(value ? value : '')} />
                        </div>
                        <div className={smallDevice ? "anomaliesHeader__actions__right-stack" : 'anomaliesHeader__actions__right-push'}>
                            <AnomalyFilters filterDisable={quickSummaryType.length > 0 ? true : false} filterClose={filterClose} onFiltersClick={() => setIsFilterOpen(!isFilterOpen)} isFilterOpen={isFilterOpen} onApplyOrReset={onApplyorReset} isOrphanFilter={true} />
                            
                            <Tooltip
                                className="custom-light-tooltip"
                                content={'Export'}
                                element={                  
                                <Button data-testid='export' 
                                className={`anomaliesHeader__actions__btn btn_export export-icon-btn`} 
                                icon={ 
                                <FontIcon
                                    iconName='fa-download'
                                    iconSize='medium'
                                  />} 
                                type="secondary"
                                 content='' 
                                 onClick={selectedInsightId.length ===0 ? displayExportToast : onExportData}
                                 />
                   
                                }
                                   position="top center"
                                   event="hover"
                                   hoverable={true}
                               />

                           {showExportPopup && (
                                <ExportAnomaly selectedInsightId={selectedInsightId} downloadExportData={downloadExportData} showExportPopup={showExportPopup} toggleClose={() => setShowExportPopup(false)} uniqueDomain={uniqueDomain} exportAnomayColumns={exportDefaultLabels} isOrphan={true} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="allopportunity">
                    {showNotesIconPopup && (
                        <Modal
                            open={showNotesIconPopup}
                            //   className="right-rail-nov"
                            size="fullscreen"
                            closeIcon={true}
                            onClose={() => setShowNotesIconPopup(false)}
                        >
                            <div className="right-section">
                             <div className="right-header">
                                 <div className="header-title">Activity</div>
                             </div>
                             <div className="content-class"><Notes
                                 role_name={notesData.role_name}
                                 onClose={() => setShowNotesIconPopup(false)}
                                 opportunityId={notesData.insight_id}
                                 opportunityStatus={notesData.insight_status}
                                 opportunityObjectName={notesData.insight_summary_object_name}
                                 isAuditTrail={false}
                                 isAllAnomalyPage={true}
                             /></div>
                             <NotesFooter
                                 onClose={() => setShowNotesIconPopup(false)}
                                 opportunityId={notesData.insight_id}
                                 opportunityObjectName={notesData.insight_summary_object_name}
                                 isAllAnomaly={true}
                             />
                         </div>
                        </Modal>
                    )}
                    <div className="allopportunity__filters-info">
                        <div className="allopportunity__filters-info--selected">{rowSelectedCount} {selectedFilterText}</div>
                        { }
                        <OverviewBadges totalRecord={totalRecord} filters={orphanFilter} onRemoveBadge={updateOrphanFilters} onClearOverviewFilter={onClearAllFilter} />
                        {Number(totalRecord) >= 10 &&
                            <div>
                                <Select
                                    className={showRowCount ? 'allopportunity__filters-info--dropdown remove-margin' : rowsNumber.length === 2 ? 'allopportunity__filters-info--dropdown' : rowsNumber.length == 0 ? 'allopportunity__filters-info--dropdown remove-margin' : 'allopportunity__filters-info--dropdown add-margin'}
                                    options={rowsOptions}
                                    value={showRowCount? "" : rowsNumber}
                                    onChange={handleChangeRowsOption}
                                    label={showRowCount ? `${data?.opportunity_detail.length} of ${totalRecord}` : rowsNumber ? `of ${totalRecord}` : `${totalRecord} of ${totalRecord}`} />
                            </div>
                        }
                    </div>
                    <div className='allopportunity__result-data'>
                        <Loader loading={gridLoading} text="Loading" className='allopportunity__gird-loader'>
                            {status !== 'error' &&
                                <div className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>
                                    <AgGridReact
                                        data-testid='grid'
                                        //@ts-ignore
                                        rowData={rowData}
                                        rowDataChangeDetectionStrategy={ChangeDetectionStrategyType.IdentityCheck}
                                        domLayout={'autoHeight'}
                                        onGridReady={onGridReady}
                                        rowSelection="multiple"
                                        onSortChanged={onCellClickSort}
                                        suppressPaginationPanel={true}
                                        rowClass="app-grid-row-style"
                                        pagination={true}
                                        paginationPageSize={rowsNumber == "" ? totalRecord : (rowsNumber ? rowsNumber : 10)}
                                        overlayLoadingTemplate={
                                            '<span className="ag-overlay-loading-center" style=" font-size: 1rem;"> Loading... </span>'
                                        }
                                        overlayNoRowsTemplate={
                                            '<span className="ag-overlay-loading-center" style=" font-size: 1rem;"> No Records Found </span>'
                                        }
                                        defaultColDef={{
                                            sortable: true,
                                            resizable: true,
                                            headerCheckboxSelection: isFirstColumn,
                                            checkboxSelection: isFirstColumn
                                        }}
                                        frameworkComponents={
                                            {
                                                opportunityCellRenderer: OpportunityCellRenderer,
                                                prevOpportunityCellRenderer: PrevOpportunityCellRenderer,
                                                actionCellRenderer: ActionCellRenderer,
                                                notesIconCellRenderer: NotesIcon,
                                                statusCellRenderer: StatusCellRenderer,
                                                actionTrackingStatusCellRenderer: ActionTrackingStatusCellRenderer,
                                                auditStatusCellRenderer: AuditStatusCellRenderer,
                                                businessStatusCellRenderer: BusinessStatusCellRenderer
                                            }}
                                        onSelectionChanged={onSelectionChanged}
                                        ref={gridRef}
                                    >

                                        <AgGridColumn headerName={anomalyIdHeader} field="insight_id"
                                            cellRenderer="opportunityCellRenderer" pinned={true} suppressSizeToFit={true}
                                        >
                                        </AgGridColumn>
                                        <AgGridColumn cellClass='text-center' headerName={prevAnomalyIdHeader} field="previous_anomaly_id"
                                            cellRenderer="prevOpportunityCellRenderer"  suppressSizeToFit={true}
                                        />
                                        <AgGridColumn headerName={alertsHeader} field="insight_summary_display_category" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={actionsHeader} field="insight_status" cellRenderer="actionCellRenderer" minWidth={150}></AgGridColumn>
                                        <AgGridColumn headerName={countryHeader} field="country_name" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={subRegionHeader} field="sub_region" suppressSizeToFit={true} ></AgGridColumn>
                                        <AgGridColumn headerName={regionHeader} field="region" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={sbgHeader} field="sbg" cellRenderer="" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={gbeHeader} cellRenderer="" field="gbe" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={spendTypeHeader} field="spend_type" suppressSizeToFit={true} ></AgGridColumn>
                                        <AgGridColumn headerName={targetGroupHeader} field="target_group" suppressSizeToFit={true}></AgGridColumn>
                                        <AgGridColumn headerName={sourceSystemHeader} field="source_system" suppressSizeToFit={true} ></AgGridColumn>
                                        <AgGridColumn headerName={companyCodeHeader} field="company_code" suppressSizeToFit={true} ></AgGridColumn>
                                        {/* @ts-ignore */}
                                    </AgGridReact>
                                    {(+totalRecord) > 0 && currentPage > 0 &&
                                        <GridPagination totalRecord={+totalRecord} itemPerPage={itemPerpage} onPageChanged={onPageChanged} isMobileDevice={smallDevice} activePage={localPageNumber} />
                                    }

                                </div>}
                            {status === 'error' &&
                                <OpportunitiesErrorCard />
                            }
                        </Loader>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default OrphanPage; 